/*
 * File: src/index.js
 * -------------------
 * Main entry point for the React application. This file is responsible for:
 *   - Importing global styles and the root App component
 *   - Rendering the App component into the DOM
 *   - Optionally reporting web vitals for performance monitoring
 *
 * To enable performance logging, pass a function to reportWebVitals (e.g., reportWebVitals(console.log)).
 */
// Import core React libraries
import React from 'react';
import ReactDOM from 'react-dom/client';
// Import global styles
import './index.css';
// Import the root App component
import App from './App';
// Import the web vitals reporting utility
import reportWebVitals from './reportWebVitals';

// Create a root DOM node for rendering the React app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode helps highlight potential problems in an application
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 